import { z } from 'zod'

/** API `processing_status` values (backend contract). */
export enum UserFileProcessingStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

/**
 * Forward-compatible runtime schema. Backend may add statuses over time.
 */
export const FileProcessingStatusSchema = z.string()

export type FileProcessingStatus = z.infer<typeof FileProcessingStatusSchema>
